{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Plantilles de Whatsapp",
      "SUBTITLE": "Selecciona la plantilla de whatsapp que vols enviar",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Cerca plantilles",
      "NO_TEMPLATES_FOUND": "No s'han trobat plantilles per a",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Categoria",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Idioma",
        "TEMPLATE_BODY": "Cos de la plantilla",
        "CATEGORY": "Categoria"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Variables",
      "LANGUAGE": "Idioma",
      "CATEGORY": "Categoria",
      "VARIABLE_PLACEHOLDER": "Introdueix el valor {variable}",
      "GO_BACK_LABEL": "Torna enrere",
      "SEND_MESSAGE_LABEL": "Envia missatge",
      "FORM_ERROR_MESSAGE": "Omple totes les variables abans d'enviar-les",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
